exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tab-content .tab-pane{padding:5px 0px\n}\n.image-container{position:relative;display:inline-block\n}\n.custom-checkbox:disabled{background-color:#ccc;cursor:not-allowed\n}", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/AgentSetting/CreateDomain2.vue"],"names":[],"mappings":";AACA,uBAAuB,eAAe;CACrC;AACD,iBAAiB,kBAAkB,oBAAoB;CACtD;AACD,0BAA0B,sBAAsB,kBAAkB;CACjE","file":"CreateDomain2.vue","sourcesContent":["\n.tab-content .tab-pane{padding:5px 0px\n}\n.image-container{position:relative;display:inline-block\n}\n.custom-checkbox:disabled{background-color:#ccc;cursor:not-allowed\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-725d43ae","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/AgentSetting/CreateDomain2.vue
// module id = oJZ+
// module chunks = 2